import { render, staticRenderFns } from "./Stripes.vue?vue&type=template&id=6dd9f280&scoped=true&lang=html"
import script from "./Stripes.vue?vue&type=script&lang=js"
export * from "./Stripes.vue?vue&type=script&lang=js"
import style0 from "./Stripes.vue?vue&type=style&index=0&id=6dd9f280&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd9f280",
  null
  
)

export default component.exports